export const contactInfo = {
    mailTo: "online@samsfurniture.co.uk",
    phone: "(01955) 606030",
    page: "/page/contact",
    facebook: "https://www.facebook.com/samsfurnitureltd",
    instagram: "https://www.instagram.com/samsfurniture118",
    twitter: "",
    pinterest: "https://cz.pinterest.com/0crz0oboafpuj7zvxue1jdp4ngpzwq/",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: true,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'SAMS',
    subtitle: 'Contact Us',
    description: 'If you wish for us to get in touch with you, please leave a note here and we will contact you as soon as possible.',
    callUs: {
        title: 'Call Us',
        subtitle: ' If you have any questions about any of our products, or wish to contact us regarding an order you have or would like to place, please contact us.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: 'You can find both our stores on the main high street in wick, Caithness.',
    where: {
        title: 'WHERE WE OPERATE',
        subtitle: '88/90 High Street Wick, Caithness KW1 4LR',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1044.0310199738146!2d-3.092315430430144!3d58.44292570470511!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x489ad6bbdf43a299%3A0x762180f06989415e!2sSofas %26 More Sofas!5e0!3m2!1sen!2scz!4v1684434591123!5m2!1sen!2scz'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday  /  Saturday'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}